import { render, staticRenderFns } from "./OrderedItems.vue?vue&type=template&id=04a40c66&scoped=true"
import script from "./OrderedItems.vue?vue&type=script&lang=js"
export * from "./OrderedItems.vue?vue&type=script&lang=js"
import style0 from "./OrderedItems.vue?vue&type=style&index=0&id=04a40c66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a40c66",
  null
  
)

export default component.exports